// extracted by mini-css-extract-plugin
export default {"input":"_1Of3p___RadioInput-module__input","label":"nUESj___RadioInput-module__label"};